import { useMemo } from "react";

import { DeepPick } from "../../../../types";
import { AiInterviewEvaluationFragment } from "../../../graphql";

type EvaluationCitations = Pick<
  AiInterviewEvaluationFragment,
  "summaryCitations" | "candidateQuestions"
> &
  DeepPick<AiInterviewEvaluationFragment, "questions", "summaryCitations"> &
  DeepPick<AiInterviewEvaluationFragment, "keyPoints", "citations">;

export const useEvaluationCitationMap = (
  aiInterviewEvaluation: EvaluationCitations | null | undefined
): Map<number, number> => {
  const summaryCitations = aiInterviewEvaluation?.summaryCitations ?? [];
  const questions = aiInterviewEvaluation?.questions ?? [];
  const keyPoints = aiInterviewEvaluation?.keyPoints ?? [];
  const candidateQuestions = aiInterviewEvaluation?.candidateQuestions ?? [];

  const citationMap = useMemo(() => {
    const map = new Map<number, number>();

    const citations = [
      ...summaryCitations,
      ...keyPoints.flatMap((kp) => kp.citations),
      ...questions.flatMap((q) => q.summaryCitations),
      ...candidateQuestions.flatMap((cq) => cq.citations),
    ].toSorted((a, b) => a - b);

    citations.forEach((c) => {
      if (!map.has(c)) {
        map.set(c, map.size + 1);
      }
    });

    return map;
  }, [aiInterviewEvaluation]);

  return citationMap;
};
